export const EVENTS = {
  RESTAURANT: {
    SHOW_RESTAURANT_DETAIL: 'restaurant.SHOW_RESTAURANT_DETAIL',
    RESTAURANT_DETAILS_REQUESTED: 'restaurant.DETAILS_REQUESTED',
    RESTAURANT_DETAIL_LOADING: 'restaurant.DETAIL_LOADING',
    RESTAURANT_DETAIL_LOADED: 'restaurant.DETAIL_LOADED',
    RESTAURANT_DETAIL_ERROR: 'restaurant.DETAIL_ERROR',
    DISHES_REQUESTED: 'restaurant.DISHES_REQUESTED',
    DISHES_LOADED: 'restaurant.DISHES_LOADED',
    DISHES_ERROR: 'restaurant.DISHES_ERROR',
    UPDATE_STATS_REQUESTED: 'restaurant.UPDATE_STATS_REQUESTED',
    UPDATE_STATS_SUCCESS: 'restaurant.UPDATE_STATS_SUCCESS',
    UPDATE_STATS_ERROR: 'restaurant.UPDATE_STATS_ERROR',
    REVIEW_REQUIRED: 'restaurant.REVIEW_REQUIRED',
    RATE: 'restaurant.RATE',
    RATED: 'restaurant.RATED',
    RATE_ERROR: 'restaurant.RATE_ERROR'
  }
};

export const ENDPOINTS = {
  RESTAURANTS: {
    DETAIL: 'https://api.monrapidoo.com/restaurant/details/{id}?group=ultraxeno',
    DRINKS: 'https://api.monrapidoo.com/restaurant/details/{restaurantId}?group=ultraxeno',
    DISHES: 'https://api.monrapidoo.com/rapidoo-aggregation/products-with-sides?group=ultraxeno&restaurantId={storeId}',
    STATS: 'https://api.monrapidoo.com/restaurant/stats/{id}?group=ultraxeno'
  }
};
